import { Card } from '@/components/ui/Card'
import { Coins } from 'lucide-react'
import type { ShopBalance as ShopBalanceType } from '@/types'

interface Props {
  balance: ShopBalanceType
}

export function ShopBalance({ balance }: Props) {
  return (
    <Card className="bg-gradient-to-r from-tessan-cream to-yellow-50">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Coins className="text-tessan-green" size={20} />
          Mon solde
        </h2>
        <div className="bg-white rounded-xl px-6 py-3 shadow-sm">
          <span className="text-3xl font-bold text-tessan-green">
            {balance.panopli_credits.toLocaleString('fr-FR')}
          </span>
          <span className="text-lg text-gray-600 ml-2">crédits</span>
        </div>
      </div>
    </Card>
  )
}
